'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
interface LazyRowProps {
  children: ReactNode;
  /** Minimum height to reserve space before content loads */
  minHeight?: string;
  /** Root margin for intersection observer (load before entering viewport) */
  rootMargin?: string;
}

/**
 * Renders children immediately without lazy loading or skeleton.
 * Previously lazy-loaded content, now renders directly for faster page load.
 */
export default function LazyRow(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}